import Index from "@/modules/thuyloi/views/Index.vue";

export default [
  {
    path: "/",
    name: "Dashboard",
    component: Index,
    redirect: { name: "MapInfo" },
    meta: { layout: "AppMap" },
    children: [
      {
        path: "/:map?",
        name: "MapInfo",
        component: () =>
          import(
            /* webpackChunkName: "InboxSearch" */ "@/modules/thuyloi/views/MapInfo.vue"
          )
      }
    ]
  }
];
